import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { gql } from 'apollo-angular';

import { DataService } from '../../providers/data/data.service';
import { LanguageService } from '../../providers/language/language.service';

export interface BrandItem {
    id: string;
    name: string;
    link: string;
    asset: { preview: string; source: string };
}

const GET_BRAND_ITEMS = gql`
    query GetBrandItemsPage {
        brandItems {
            id
            name
            link
            asset {
                preview
                source
            }
        }
    }
`;

@Component({
    selector: 'vsf-brands-page',
    templateUrl: './brands-page.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrandsPageComponent implements OnInit {
    brands$: Observable<BrandItem[]>;

    private isNonEnglish: boolean;

    constructor(
        private dataService: DataService,
        private languageService: LanguageService,
    ) {
        this.isNonEnglish = this.languageService.currentLanguage !== 'en';
    }

    ngOnInit(): void {
        this.brands$ = (this.isNonEnglish
            ? this.dataService.queryFresh<{ brandItems: BrandItem[] }>(GET_BRAND_ITEMS)
            : this.dataService.query<{ brandItems: BrandItem[] }>(GET_BRAND_ITEMS)
        ).pipe(map(data => data.brandItems ?? []));
    }
}
